import type { ReactNode } from "react";
import { Avatar, Dropdown } from "antd";
import type { MenuProps } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import "./AccountMenu.css";

export interface AccountMenuAction {
  key: string;
  label: ReactNode;
  icon?: ReactNode;
  danger?: boolean;
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void | Promise<void>;
}

interface AccountMenuProps {
  username: string;
  avatarUrl?: string | null;
  actions: AccountMenuAction[];
}

const AccountMenu = ({ username, avatarUrl, actions }: AccountMenuProps) => {
  const isLoading = actions.some((action) => action.loading);
  const items: MenuProps["items"] = actions.map((action) => ({
    key: action.key,
    label: action.label,
    icon: action.loading ? <LoadingOutlined spin /> : action.icon,
    danger: action.danger,
    disabled: action.disabled || action.loading,
  }));

  const handleMenuClick: MenuProps["onClick"] = ({ key }) => {
    const action = actions.find((candidate) => candidate.key === key);
    if (action && !action.disabled && !action.loading) {
      void action.onClick();
    }
  };

  return (
    <Dropdown
      menu={{ items, onClick: handleMenuClick }}
      placement="bottomRight"
      trigger={["click"]}
      overlayClassName="account-menu-dropdown"
    >
      <button
        type="button"
        className="account-menu-trigger"
        aria-label="アカウントメニュー"
        disabled={isLoading}
      >
        <span className="account-menu-username">{username}</span>
        <Avatar
          className="account-menu-avatar"
          size={28}
          src={isLoading ? undefined : avatarUrl || undefined}
          alt={`${username} avatar`}
        >
          {isLoading ? (
            <LoadingOutlined spin />
          ) : (
            username.charAt(0).toUpperCase()
          )}
        </Avatar>
      </button>
    </Dropdown>
  );
};

export default AccountMenu;
